// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { blue } from './primitiveColors/blue';
import { common } from './primitiveColors/common';
import { cyan } from './primitiveColors/cyan';
import { green } from './primitiveColors/green';
import { grey } from './primitiveColors/grey';
import { magenta } from './primitiveColors/magenta';
import { mutedBlue, mutedGreen, mutedPurple, mutedRed, mutedYellow } from './primitiveColors/muted';
import { orange } from './primitiveColors/orange';
import { purple } from './primitiveColors/purple';
import { red } from './primitiveColors/red';
import { transparency } from './primitiveColors/transparency';
import { yellow } from './primitiveColors/yellow';
import { background } from './themeColors/background';
import { border } from './themeColors/border';
import { icon } from './themeColors/icon';
import { line } from './themeColors/line';
import { text } from './themeColors/text';
var sharedPalettes = {
    success: {
        main: green[600],
        dark: green[900],
        light: green[50],
        contrastText: common.white
    },
    info: {
        main: blue[500],
        dark: blue[900],
        light: blue[50],
        contrastText: common.white
    },
    warning: {
        main: yellow[500],
        dark: yellow[900],
        light: yellow[50],
        contrastText: grey[600]
    },
    error: {
        main: red[600],
        dark: red[900],
        light: red[50],
        contrastText: common.white
    },
    default: {
        main: grey[400],
        dark: grey[900],
        light: grey[100],
        contrastText: common.black
    },
    support: {
        main: purple[600],
        dark: purple[900],
        light: purple[50],
        contrastText: common.black
    },
    special: {
        main: purple[600],
        dark: purple[900],
        light: purple[50],
        contrastText: common.white
    },
    defaultBold: {
        main: grey[900],
        dark: grey[900],
        light: grey[100],
        contrastText: common.white
    },
    // Chip color="gray" requires a palette entry so MUI Chip can access
    // .main/.contrastText/.dark without throwing. Actual chip styles come from
    // the Chip variants override in Chip.tsx, not from these palette values.
    gray: {
        main: grey[200],
        dark: grey[300],
        light: grey[100],
        contrastText: grey[900]
    },
    grey: grey,
    blue: blue,
    cyan: cyan,
    green: green,
    red: red,
    yellow: yellow,
    purple: purple,
    orange: orange,
    magenta: magenta,
    mutedBlue: mutedBlue,
    mutedGreen: mutedGreen,
    mutedPurple: mutedPurple,
    mutedRed: mutedRed,
    mutedYellow: mutedYellow,
    transparency: transparency
};
var light = _object_spread({
    primary: {
        main: grey[600],
        dark: grey[800],
        light: blue[400],
        contrastText: common.white
    },
    secondary: {
        main: grey[500],
        dark: grey[700],
        light: grey[200],
        contrastText: common.white
    },
    background: _object_spread_props(_object_spread({}, background('light')), {
        paper: common.white,
        default: common.white
    }),
    text: text('light'),
    border: border('light'),
    icon: icon('light'),
    line: line('light')
}, sharedPalettes);
var darkBg = background('dark');
var dark = _object_spread({
    primary: {
        main: grey[50],
        dark: grey[200],
        light: blue[400],
        contrastText: common.black
    },
    secondary: {
        main: grey[200],
        dark: grey[500],
        light: grey[200],
        contrastText: common.black
    },
    background: _object_spread_props(_object_spread({}, darkBg), {
        default: darkBg.level0,
        paper: darkBg.level50
    }),
    text: text('dark'),
    border: border('dark'),
    icon: icon('dark'),
    line: line('dark')
}, sharedPalettes);
export var palette = {
    light: light,
    dark: dark
};

//# sourceMappingURL=palette.js.map